import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';

import { DirectivesModule } from '@directives/directives.module';

import { TaToggleComponent } from './ta-toggle.component';

import { RequiredValidator } from '../ta-validators';

@NgModule({
    declarations: [TaToggleComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DirectivesModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-toggle',
                    component: TaToggleComponent,
                    defaultOptions: {
                        validators: {
                            required: RequiredValidator,
                        }
                    }
                }
            ]
        })
    ]
})
export class TaFormlyToggleModule { }
